import React, { useEffect, useState } from "react"
import "./AddOrder.css"
import { Button, Pagination, Nav } from "react-bootstrap"
import Cookies from "js-cookie"
import { useNavigate } from "react-router-dom"
import AnimacionSuccessful from "../../AnimacionSuccessful/animacionSuccessful"
import UserSelectionDropbox from "./Components/UserSelectionDropbox"
import LabSelectionDropbox from "./Components/LabSelectionDropbox"
import ProductsTable from "./Components/ProductsTable"
import SearchInput from "./Components/SearchInput"
import api from "../../../utils/axios"
import { useOrderEligibility } from "../../../CustomHook/useOrderEligibility"

export default function AddOrder() {
	const navigate = useNavigate()
	const [allProducts, setAllProducts] = useState([])
	const [allOtherProducts, setAllOtherProducts] = useState([])
	const [userLabType, setUserLabType] = useState("")
	const [selectedProducts, setSelectedProducts] = useState([])
	const [selectedOtherProducts, setSelectedOtherProducts] = useState([])
	const errorMessages = ""
	const otherProductsErrorMessages = ""
	const [variable, setVariable] = useState(false)
	const [errorBool, setErrorBool] = useState(false)
	const [avisomsg, setAvisomsg] = useState("")
	const [users, setUsers] = useState([])
	const role = Cookies.get("role")
	const [tabSection, setTabSection] = useState("biochemicals")
	const [search, setSearch] = useState("")
	const [userCategoriesAssigned, setUserCategoriesAssigned] = useState([])
	const [biochemicalsNotAllowed, setBiochemicalsNotAllowed] = useState(false)
	//console.log(allOtherProducts)

	// Vista sede
	const [labsFromUser, setLabsFromUser] = useState([])
	const [labSelected, setLabSelected] = useState("")

	const [isLoadingLabProducts, setIsLoadingLabProducts] = useState(false)

	const [labProductsData, setLabProductsData] = useState(null)
	const { eligibility, loading: eligibilityLoading, error: eligibilityError, refetch } = useOrderEligibility(labSelected)
	const labEligibility = eligibility?.labs?.find(lab => lab.labId === labSelected)
	const canPlaceOrder = labEligibility?.canPlaceOrder ?? false
	const canAccessVarious = role !== "sede" || canPlaceOrder
	const variousBlockedReason =
		role === "sede" && labSelected && eligibility && !canPlaceOrder
			? eligibility.reason || (eligibility.window?.isOpen ? "QUOTA_EXHAUSTED" : "OUT_OF_WINDOW")
			: null
	const variousBlockedMessage =
		variousBlockedReason === "OUT_OF_WINDOW"
			? "Fuera del período de pedidos"
			: variousBlockedReason === "QUOTA_EXHAUSTED"
				? "Sin cupo disponible este mes"
				: ""

	const [isAddOrdenButtonDisabled, setIsAddOrdenButtonDisabled] = useState(false)

	// Paginación de productos
	const [productPageNumber, setProductPageNumber] = useState(0)
	const [otherProductsPageNumber, setOtherProductsPageNumber] = useState(0)
	const [otherProductsStartIndex, setOtherProductsStartIndex] = useState()
	const [otherProductsEndIndex, setOtherProductsEndIndex] = useState()
	const [otherProductsPageCount, setOtherProductsPageCount] = useState()
	const productsPerPage = 10

	const productsStartIndex = productPageNumber * productsPerPage
	const productsEndIndex = productsStartIndex + productsPerPage
	// Contador de páginas
	const productsPageCount = Math.ceil(allProducts.length / productsPerPage)

	useEffect(() => {
		const startIndex = otherProductsPageNumber * productsPerPage;

		setOtherProductsStartIndex(startIndex);
		setOtherProductsEndIndex(startIndex + productsPerPage);
		setOtherProductsPageCount(Math.ceil(allOtherProducts.length / productsPerPage));
	}, [allOtherProducts, otherProductsPageNumber])

	// Handlers Paginacion

	const handleProductsChangePage = selected => {
		setProductPageNumber(selected)
	}

	const handleOtherProductsChangePage = selected => {
		setOtherProductsPageNumber(selected)
	}

	// Obtengo los productos asociados al usuario sede
	useEffect(() => {
		; (async function () {
			try {
				if (role === "sede" || role === "logistic") {
					const response = await api.get("/laboratory/my-order-labs");

					setUserLabType(response.data.username || "");
					setLabsFromUser(response.data.labs || []);

					if (role === "sede") {
					const biochemicalsBlocked = Boolean(response.data.biochemicalsNotAllowed);

					setBiochemicalsNotAllowed(biochemicalsBlocked);

					if (biochemicalsBlocked) {
						setTabSection("various");
						}
					}
				} else if (role === "admin") {
					if (!users.length) {
						const usersResponse = await api.get("/users/order-candidates");
						setUsers(usersResponse.data.users || []);
					}
				}
			} catch (error) {
				console.log("Error al obtener productos del usuario:", error);
			}
		})()
	}, [role])

	useEffect(() => {
		if (role !== "admin" || !userLabType || !users.length) return;

		const userSelected = users.find(user => user.username === userLabType);

		if (!userSelected) {
			setLabsFromUser([]);
			return;
		}

		setLabsFromUser(userSelected.labs || []);
	}, [role, userLabType, users])

	useEffect(() => {
		if (!labSelected) {
			setLabProductsData(null)
			setAllProducts([])
			setAllOtherProducts([])
			setIsLoadingLabProducts(false)
			return
		}

		;(async () => {
			try {
			setIsLoadingLabProducts(true)

			const response = await api.get(`/laboratory/${labSelected}/order-products`)
			setLabProductsData(response.data.lab || null)
			} catch (error) {
			console.log("Error al obtener productos del laboratorio:", error)
			setLabProductsData(null)
			setAllProducts([])
			setAllOtherProducts([])
			} finally {
			setIsLoadingLabProducts(false)
			}
		})()
	}, [labSelected])

	useEffect(() => {
		if (!labSelected) {
			setAllProducts([]);
			setAllOtherProducts([]);
			return;
		}

		const labSelectedData = labProductsData;

		if (!labSelectedData) {
			setAllProducts([]);
			setAllOtherProducts([]);
			return;
		}

		const normalizedSearch = search.toLowerCase();

		const filteredProductTags = (labSelectedData.tags || [])
			.filter(tag => tag.isProducts)
			.filter(tag => {
				const matchesTag = tag.name?.toLowerCase().includes(normalizedSearch);
				const matchesProducts = (tag.products || []).some(product =>
					product.name?.toLowerCase().includes(normalizedSearch)
				);

				return matchesTag || matchesProducts;
			})
			.map(tag => ({ ...tag, isTag: true }));

		const filteredProducts = (labSelectedData.products || []).filter(product =>
			product.name?.toLowerCase().includes(normalizedSearch)
		);

		setAllProducts(
			role === "sede"
				? filteredProductTags
				: [...filteredProductTags, ...filteredProducts]
		);

		const filteredOtherProductTags = (labSelectedData.tags || [])
			.filter(tag => !tag.isProducts)
			.filter(tag => {
				const matchesTag = tag.name?.toLowerCase().includes(normalizedSearch);
				const matchesProducts = (tag.otherProducts || tag.products || []).some(product =>
					product.name?.toLowerCase().includes(normalizedSearch)
				);

				return matchesTag || matchesProducts;
			})
			.map(tag => ({ ...tag, isTag: true }));

		const filteredOtherProducts = (labSelectedData.otherProducts || []).filter(product =>
			product.name?.toLowerCase().includes(normalizedSearch)
		);

		setAllOtherProducts(
			role === "sede"
				? filteredOtherProductTags
				: [...filteredOtherProductTags, ...filteredOtherProducts]
		);
	}, [labSelected, search, labProductsData, role])


	// Obtener las categorias
	const getCategoryById = async id => {
		const response = await api.get(`/categories/${id}`)

		return response.data
	}

	// Manejar productos seleccionados
	const handleAddOrRemoveItems = (id, isTag, isProducts) => {
		if (isProducts) {
			if (selectedProducts.some(p => p.id === id)) {
				setSelectedProducts(prev => prev.filter(p => p.id !== id))
			} else {
				setSelectedProducts(prev => [...prev, { id, quantityRequested: "1", isTag, isProducts }])
			}
		} else {
			if (selectedOtherProducts.some(p => p.id === id)) {
				setSelectedOtherProducts(selectedOtherProducts.filter(p => p.id !== id))
			} else {
				setSelectedOtherProducts([...selectedOtherProducts, { id, quantityRequested: "1", isTag, isProducts }])
			}
		}

	}

	const handleEditItems = (id, quantity, isProducts) => {
		if (isProducts) {
			setSelectedProducts(prev => prev.map(product => {
				if (product.id === id) {
					return { ...product, quantityRequested: quantity }
				} else {
					return product
				}
			}))
		} else {
			setSelectedOtherProducts(prev => prev.map(product => {
				if (product.id === id) {
					return { ...product, quantityRequested: quantity }
				} else {
					return product
				}
			}))
		}
	}

	const createOrder = async ({ isAdmin }) => {
		// Validación de cantidades antes de enviar
		const allSelectedItems = [...selectedProducts, ...selectedOtherProducts]
		const invalidItems = allSelectedItems.filter(item => {
			const qty = Number(item.quantityRequested)
			return !item.quantityRequested || isNaN(qty) || qty < 1
		})

		if (invalidItems.length > 0) {
			setErrorBool(true)
			setVariable(true)
			setAvisomsg("Todos los productos seleccionados deben tener una cantidad mayor a 0.")
			setTimeout(() => {
				setVariable(false)
			}, 3200)
			return
		}

		setIsAddOrdenButtonDisabled(true)

		const productsToOrder = selectedProducts.filter(product => !product.isTag)
		const otherProductsToOrder = selectedOtherProducts.filter(product => !product.isTag)
		const productTagsToOrder = selectedProducts.filter(product => product.isTag)
		const otherProductTagsToOrder = selectedOtherProducts.filter(product => product.isTag)

		const hasBiochemicalItems = productsToOrder.length > 0 || productTagsToOrder.length > 0
		const hasVariousItems = otherProductsToOrder.length > 0 || otherProductTagsToOrder.length > 0

		if (hasBiochemicalItems && hasVariousItems) {
			setErrorBool(true)
			setVariable(true)
			setAvisomsg("No se pueden mezclar productos bioquímicos y varios en el mismo pedido. Realizá pedidos separados.")
			setIsAddOrdenButtonDisabled(false)
			setTimeout(() => {
				setVariable(false)
			}, 3200)
			return
		}

		try {
			await api.post("/pedidos/add", {
				username: userLabType,
				products: productsToOrder,
				otherProducts: otherProductsToOrder,
				productTags: productTagsToOrder,
				otherProductTags: otherProductTagsToOrder,
				isFromAdmin: isAdmin ? true : false,
				labOrigin: labSelected,
			})

			await refetch()

			setVariable(true)
			setErrorBool(false)
			setAvisomsg("Pedido cargado con éxito!")

			setTimeout(() => {
				setVariable(false)
				navigate("/orders")
			}, 1200)
		} catch (error) {
			setErrorBool(true)
			setVariable(true)
			setAvisomsg(error.response?.data?.msg || "No pudimos cargar el pedido.")
			setTimeout(() => {
				setVariable(false)
				setIsAddOrdenButtonDisabled(false)
			}, 3200)
		}
	}
	const handleTabChange = section => {
		setTabSection(section)
	}

	const handleLabSelectedChange = labId => {
		setLabSelected(labId)

		setLabProductsData(null)

		setIsLoadingLabProducts(Boolean(labId))

		setSelectedProducts([])

		setSelectedOtherProducts([])
		setSearch("")

	}

	const handleUserLabTypeChange = userId => {
		setUserLabType(userId)
		handleLabSelectedChange("")
	}

	return (
		<>
			<div className="main-container">
				<div className="header--container">
					<div className="order--header-cont">
						<div className="order--header-row">
							<h1 className="order--title">Carga pedido</h1>

						</div>
						<div className="order-row-select">
							{/* Selección de usuario si es admin */}
							{role === "admin" && (
								<UserSelectionDropbox
									handleUserLabTypeChange={handleUserLabTypeChange}
									userLabType={userLabType}
									users={users}
								/>
							)}

							{/* Selección de laboratorio */}
							{(role === "sede" || role === "logistic" || userLabType) && (
								<LabSelectionDropbox
									labSelected={labSelected}
									labsFromUser={labsFromUser}
									handleLabSelectedChange={handleLabSelectedChange}
								/>

							)}

						</div>
					</div>
				</div>
				<div className="card--container">
					<div className="header-table-order">
						<Nav className="nav-tabs">
							<Nav.Item>
								<Nav.Link
									eventKey="biochemicals"
									onClick={() => handleTabChange("biochemicals")}
									active={tabSection === "biochemicals"}
									disabled={biochemicalsNotAllowed}
								>
									Bioquímicos
								</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link
									eventKey="various"
									onClick={() => handleTabChange("various")}
									active={tabSection === "various"}
								>
									Varios
								</Nav.Link>
							</Nav.Item>
						</Nav>
						<SearchInput
							search={search}
							onChange={e => {
								setSearch(e.target.value)
								handleProductsChangePage(0)
								handleOtherProductsChangePage(0)
							}}
						/>


					</div>
					{/* Tab y filtro por nombre */}


					<div className="table-container-new">
						<div className="table-striped table-bordered table-hover">
							{isLoadingLabProducts ? (
								<div style={{ textAlign: "center" }}>
									Cargando productos del laboratorio...
								</div>
							) : !labSelected ? (
								<div style={{ textAlign: "center" }}>
									Seleccione laboratorio.
								</div>
							) : tabSection === "biochemicals" && !(role === "sede" && biochemicalsNotAllowed) ? (
							allProducts.length > 0 ? (
								<ProductsTable
								allItems={allProducts}
								errorMessages={errorMessages}
								handleAddOrRemoveItems={handleAddOrRemoveItems}
								handleEditItems={handleEditItems}
								itemsStartIndex={productsStartIndex}
								itemsEndIndex={productsEndIndex}
								selectedItems={selectedProducts}
								role={role}
								tabSection={tabSection}
								isProduct
								/>
							) : (
								<div style={{ textAlign: "center" }}>
								No hay productos bioquímicos asignados a este laboratorio.
								</div>
							)
							) : tabSection === "various" && canAccessVarious ? (
							allOtherProducts.length > 0 ? (
								<>
								{labEligibility?.extraOrder && (
									<h4 style={{ marginBottom: "16px", color: "#056a6c", fontSize: "20px" }}>
									Pedido extra
									</h4>
								)}

								<ProductsTable
									allItems={allOtherProducts}
									errorMessages={otherProductsErrorMessages}
									handleAddOrRemoveItems={handleAddOrRemoveItems}
									handleEditItems={handleEditItems}
									itemsStartIndex={otherProductsStartIndex}
									itemsEndIndex={otherProductsEndIndex}
									selectedItems={selectedOtherProducts}
									role={role}
								/>
								</>
							) : (
								<div style={{ textAlign: "center" }}>
								No hay productos de tipo varios asignados a este laboratorio.
								</div>
							)
							) : (
							<>
								{tabSection === "various" && role === "sede" && labSelected && eligibilityLoading && !eligibility ? (
								<p
									style={{
									textAlign: "center",
									fontSize: "18px",
									fontWeight: 400,
									marginTop: "12px",
									}}
								>
									Verificando disponibilidad para realizar pedidos.
								</p>
								) : tabSection === "various" && role === "sede" && labSelected && eligibilityError ? (
								<p style={{ textAlign: "center" }}>
									No pudimos verificar el cupo disponible en este momento.
								</p>
								) : tabSection === "various" && role === "sede" && labSelected && variousBlockedMessage ? (
								<p style={{ textAlign: "center" }}>
									{variousBlockedMessage}
								</p>
								) : (
								<p style={{ textAlign: "center" }}>Seleccione laboratorio.</p>
								)}
							</>
							)}
						</div>
					</div>

					{/* Paginación */}
					{/* Paginación */}
					{(
						(tabSection === "biochemicals" && allProducts.length > 0 && productsPageCount > 1) ||
						(tabSection === "various" && allOtherProducts.length > 0 && otherProductsPageCount > 1)
					) && (
							<div className="pagination-order pagination-all-tag">
								{tabSection === "biochemicals" ? (
									<Pagination>
										<Pagination.Prev
											onClick={() =>
												handleProductsChangePage(
													productPageNumber > 0 ? productPageNumber - 1 : 0
												)
											}
											disabled={productPageNumber === 0}
										/>

										{Array.from({ length: productsPageCount }).map((_, index) => {
											const shouldShow = Math.abs(index - productPageNumber) <= 2;
											if (!shouldShow) return null;

											return (
												<Pagination.Item
													className="pagination-item"
													key={index}
													active={index === productPageNumber}
													onClick={() => handleProductsChangePage(index)}
												>
													{index + 1}
												</Pagination.Item>
											);
										})}

										<Pagination.Next
											onClick={() =>
												handleProductsChangePage(
													productPageNumber < productsPageCount - 1
														? productPageNumber + 1
														: productsPageCount - 1
												)
											}
											disabled={productPageNumber === productsPageCount - 1}
										/>
									</Pagination>
								) : tabSection === "various" &&
									canAccessVarious ? (
									<Pagination>
										<Pagination.Prev
											onClick={() =>
												handleOtherProductsChangePage(
													otherProductsPageNumber > 0
														? otherProductsPageNumber - 1
														: 0
												)
											}
											disabled={otherProductsPageNumber === 0}
										/>

										{Array.from({ length: otherProductsPageCount }).map((_, index) => {
											const shouldShow = Math.abs(index - otherProductsPageNumber) <= 2;
											if (!shouldShow) return null;

											return (
												<Pagination.Item
													className="pagination-item"
													key={index}
													active={index === otherProductsPageNumber}
													onClick={() => handleOtherProductsChangePage(index)}
												>
													{index + 1}
												</Pagination.Item>
											);
										})}

										<Pagination.Next
											onClick={() =>
												handleOtherProductsChangePage(
													otherProductsPageNumber < otherProductsPageCount - 1
														? otherProductsPageNumber + 1
														: otherProductsPageCount - 1
												)
											}
											disabled={otherProductsPageNumber === otherProductsPageCount - 1}
										/>
									</Pagination>
								) : null}
							</div>
						)}


					{/* Botones */}
					<div className="content-card-order">
						<Button
							className="button-carga-order"
							children="Generar Pedido"
							onClick={() => createOrder({ isAdmin: role === "sede" ? false : true })}
							disabled={
								isAddOrdenButtonDisabled ||
								isLoadingLabProducts ||
								labSelected === "" ||
								(!selectedProducts.length && !selectedOtherProducts.length)
							}
						/>
					</div>
				</div>
			</div>
			{/* Modal de estado */}
			{variable && (
				<AnimacionSuccessful
					errorBool={errorBool}
					avisomsg={avisomsg}
				/>
			)}
		</>
	)
}
